export default function generateTicketId(passenger_number_id) {
  // Переводимо passenger_number_id у рядок та заповнюємо нулями до 5 символів
  const ticketId = String(passenger_number_id).padStart(5, '0');
  return ticketId;
}
